import useRequest, {
    RequestFn,
    RequestKeys,
} from 'app/hooks/useRequest'
import StatusHandler from 'app/shared-components/StatusHandler'
import requests from 'app/requests/Quote/SimplifiedQuote.requests'
import {
    SimplifiedCQuote,
} from '../SimplifiedCQuotes.types'
import SimplifiedCQuoteForm from '../SimplifiedCQuoteForm'

export default function SimplifiedCQuoteOverview({
    id,
}: Readonly<{ id: number }>) {
    const {
        data,
        isDataReady,
        isError,
        isFetching,
        error,
    } = useRequest<SimplifiedCQuote>({
        key: RequestKeys.getSimplifiedCQuote,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: !!id,
        keepPreviousData: true,
    })

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isError={isError}
            error={error}
            isFetching={isFetching}
        >
            <SimplifiedCQuoteForm
                disabled
                data={data}
            />
        </StatusHandler>
    )
}
